
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surveys",
      function () {
        return require("private-next-pages/surveys/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surveys"])
      });
    }
  